<div class="summary-container">
  <div class="summary-content">
    <span class="title">{{ 'commission.new.summary.title' | translate }}</span>

    <div class="info-list">
      <div class="info-row">
        <span class="label">{{ 'commission.new.summary.name' | translate }}</span>
        <span class="value">{{ commission.name || "--" }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'commission.new.summary.type' | translate }}</span>
        <span class="value tag neutral">{{ 'commission.type.' + commission.commission_type | translate  }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'commission.new.summary.base_percent' | translate }}</span>
        <span class="value">
          {{ commission.commission }}% <span style="margin-left: 20px; color: #868e96">{{ calculationTypeDesc }}</span>
        </span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'commission.new.summary.thresholds' | translate }}</span>
        <span class="value">{{ commission.thresholds.length }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'commission.new.summary.negotiations_rules' | translate }}</span>
        <span class="value">
          {{ commission.negotiations.length }}
        </span>
      </div>
    </div>
    <div class="interactive-preview">
      <div class="preview-header">{{ 'commission.new.summary.preview' | translate }}</div>
      <div style="display: flex; gap: 20px">
        <div class="preview-inputs">
          <div class="standard-input has-icon">
            <label for="order-value">{{ 'commission.new.summary.order_value' | translate }}</label>
            <div class="input-container">
              <input type="number" name="order-value" min="0" [formControl]="orderValue" />
              <span class="btn-icon" style="cursor: default">€</span>
            </div>
          </div>
          <div class="standard-input has-icon">
            <label for="extra-discount">{{ 'commission.new.summary.extra_discount' | translate }}</label>
            <div class="input-container">
              <input type="number" name="extra-discount" min="0" [formControl]="orderExtraDiscount" />
              <span class="btn-icon" style="cursor: default">%</span>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; gap: 20px; flex: 1">
          <div class="preview-details">
            <div class="detail-block">
              <span class="info-title">{{ 'commission.new.base_commission' | translate }}</span>
              <div class="info-block">
                <span class="info-value" *ngIf="AppliedRule?.type === 'base'">{{ AppliedRule?.commission }}%</span>
                <span class="tag" [class.neutral]="AppliedRule?.type === 'base'">{{ (AppliedRule?.type === "base" ? "commission.new.summary.applied" : "commission.new.summary.not_applied") | translate }}</span>
              </div>
            </div>
            <div class="detail-block">
              <span class="info-title">{{ 'commission.new.summary.threshold' | translate }}</span>
              <div class="info-block">
                <span class="info-value" *ngIf="AppliedRule?.type === 'threshold'">{{ AppliedRule?.commission }}%</span>
                <span class="tag" [class.neutral]="AppliedRule?.type === 'threshold'">{{
                  (AppliedRule?.type === "threshold" ? "commission.new.summary.applied" : "commission.new.summary.not_applied") | translate
                }}</span>
              </div>
            </div>
            <div class="detail-block">
              <span class="info-title">{{ 'commission.new.summary.negotiation_rule' | translate }}</span>
              <div class="info-block">
                <span class="info-value" *ngIf="AppliedRule?.type === 'negotiation'">{{ AppliedRule?.commission }}%</span>
                <span class="tag" [class.neutral]="AppliedRule?.type === 'negotiation'">{{
                  (AppliedRule?.type === "negotiation" ? "commission.new.summary.applied" : "commission.new.summary.not_applied") | translate
                }}</span>
              </div>
            </div>
          </div>
          <hr />
          <div class="preview-results">
            <div class="result-block">
              <span class="info-title">{{ 'commission.new.summary.final_order_value' | translate }}</span>
              <div class="info-block">
                <span class="info-value">
                  {{
                    FinalOrderValue.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}€
                </span>
              </div>
            </div>
            <div class="result-block">
              <span class="info-title">{{ 'commission.new.summary.final_commission' | translate }}</span>
              <div class="info-block">
                <span class="info-value">
                  {{
                    CommissionValue.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}€
                </span>
                <span class="result-percent">{{ AppliedRule?.commission || 0 }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="getCommissionInfoBoxValues() as info">
        <ng-container *ngIf="info.minCommission || info.maxCommission">
          <div class="preview-disclaimer">
            <span style="color: #6449DB">
              <app-svg-icon svgIcon="info-cc"></app-svg-icon>
            </span>
            <div style="flex: 1">
              <div *ngIf="info.maxCommission">
                <!-- The maximum commission allowed by this Profile is -->
                {{ 'commission.new.summary.max_commission_allowed' | translate }}
                <b>{{ info.maxCommission }}%</b>
                <ng-container *ngIf="info.maxCommissionType === 'threshold' && info.maxCommissionContext?.minOrderValue != null">
                  , <!-- for orders over --> {{ 'commission.new.summary.for_orders_over' | translate }}
                  <b>{{
                    info.maxCommissionContext.minOrderValue.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</b>€
                </ng-container>
                <ng-container *ngIf="info.maxCommissionType === 'negotiation' && info.maxCommissionContext?.maxExtraDiscount != null">
                  <!-- , when Max Extra commission is applied (Extra Discount: <b>{{ info.maxCommissionContext.maxExtraDiscount }}%</b>) -->
                  {{ 'commission.new.summary.when_max_extra_commission' | translate : { extra_discount: info.maxCommissionContext.maxExtraDiscount} }}
                </ng-container>
                <ng-container *ngIf="info.maxCommissionType === 'base'"> ({{ 'commission.new.base_commission' | translate }})</ng-container>.
              </div>
              <div *ngIf="info.minCommission">
                <!-- The minimum commission allowed by this Profile is -->
                {{ 'commission.new.summary.min_commission_allowed' | translate }}
                <b>{{ info.minCommission }}%</b>
                <ng-container *ngIf="info.minCommissionType === 'negotiation' && info.minCommissionContext?.maxExtraDiscount != null">
                  <!-- , when Max Extra commission is applied (Extra Discount: <b>{{ info.minCommissionContext.maxExtraDiscount }}%</b>) -->
                  {{ 'commission.new.summary.when_max_extra_commission' | translate : { extra_discount: info.minCommissionContext.maxExtraDiscount} }}
                </ng-container>
                <ng-container *ngIf="info.minCommissionType === 'threshold' && info.minCommissionContext?.minOrderValue != null">
                  , <!-- for orders over --> {{ 'commission.new.summary.for_orders_over' | translate }}
                  <b>{{
                    info.minCommissionContext.minOrderValue.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</b>€
                </ng-container>
                <ng-container *ngIf="info.minCommissionType === 'base'"> ({{ 'commission.new.base_commission' | translate }})</ng-container>.
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <hr />
    <div class="agents-section">
      <span class="title">{{ 'commission.new.summary.assign_profile_agents' | translate }} <span class="secondary-text">({{ 'common.optional' | translate }})</span></span>
      <div class="agents-container">
        <div class="filters">
          <div class="search-filter-group">
            <!-- Search Box -->
            <div class="standard-input has-icon search-box">
              <div class="input-container">
                <input type="text" placeholder="{{ 'agent.listing.search' | translate }}" [formControl]="searchInput" (input)="search($event)" />
                <span class="btn-icon" style="cursor: default">
                  <app-svg-icon svgIcon="search_icon"></app-svg-icon>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="agents-content">
          <table class="agents-table">
            <thead>
              <tr class="row header">
                <th>
                  <mat-checkbox [checked]="isAllAgentsSelected()" [indeterminate]="isPartialSelectedAll()" (change)="toggleAllAgents($event.checked)">
                  </mat-checkbox>
                  <div [title]="'agent.listing.fullname' | translate">
                    {{ "agent.listing.fullname" | translate }}
                  </div>
                </th>
                <th [title]="'commission.new.base_commission' | translate">{{ 'commission.new.base_commission' | translate }}</th>
                <th [title]="'commission.new.summary.brand_commission' | translate">{{ 'commission.new.summary.brand_commission' | translate }}</th>
                <th [title]="'commission.new.summary.agent_override' | translate">{{ 'commission.new.summary.agent_override' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <cdk-virtual-scroll-viewport itemSize="50" class="agents-viewport">
                <ng-container *cdkVirtualFor="let agent of filteredAgents; trackBy: trackByAgentId">
                  <tr class="row">
                    <!-- Agent's fullname -->
                    <td>
                      <mat-checkbox
                        [disableRipple]="true"
                        [checked]="selectedAgents.includes(agent.id!)"
                        (change)="toggleAgent(agent.id!, $event.checked)"
                        (click)="$event.stopPropagation()"
                      ></mat-checkbox>
                      <span class="truncate" style="width: 200px" [title]="agent.first_name + ' ' + agent.last_name">
                        {{ agent.first_name + " " + agent.last_name }}
                      </span>
                    </td>
                    <!-- Base Commission -->
                    <td>--</td>
                    <!-- Brand Commission Count -->
                    <td>0</td>
                    <!-- Agent Override -->
                    <td>--</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="!agents.length">
                  <div style="height: 200px; display: flex; align-items: center; justify-content: center" class="secondary-text">
                    {{ "agent.listing.no_data" | translate }}
                  </div>
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button type="button" class="action-btn secondary-btn" (click)="previous()">
      <span class="icon">
        <img src="assets/icones/arrow-back-black.svg" alt="" />
      </span>
      {{ "agent.actions.back" | translate }}
    </button>
    <button type="button" class="action-btn primary-btn" (click)="create()">
      {{ "commission.actions.create_profile_short" | translate }}
      <span class="icon">
        <img src="assets/icones/arrow-right.svg" alt="" />
      </span>
    </button>
  </div>
</div>
